import type { FormSchema } from "./types";

export function validateForm(
    schema: FormSchema,
    values: Record<string, string>
): Record<string, string> {
    const errors: Record<string, string> = {};

    for (const field of schema.fields) {
        if (field.type === "hidden") continue;

        const value = values[field.name]?.trim() ?? "";

        if (field.type === "checkbox") {
            const checkedValue = field.checkedValue ?? "true";

            if (field.required && value !== checkedValue && value !== "true") {
                errors[field.name] = "This field is required";
            }

            continue;
        }

        if (field.required && !value) {
            errors[field.name] = "This field is required";
            continue;
        }

        if (field.minLength && value.length < field.minLength) {
            errors[field.name] = `Must be at least ${field.minLength} characters`;
        }

        if (field.maxLength && value.length > field.maxLength) {
            errors[field.name] = `Must be less than ${field.maxLength} characters`;
        }

        if (field.type === "email" && value) {
            if (!/^\S+@\S+\.\S+$/.test(value)) {
                errors[field.name] = "Invalid email address";
            }
        }
    }

    return errors;
}
